<script setup>

import {computed, inject, ref} from "vue";
import {useI18n} from "vue-i18n";
const $log = inject('log');
const { t } = useI18n();
import { DateTime,Settings } from 'luxon';
import xml2json, {xml2js} from 'xml-js';
Settings.defaultZone = 'Europe/Vienna'; // might be redundant

const fileInput = ref(null);
const fileCamtToAnalyse = ref(null)
const fileCamtToAnalyseContexnts = ref("")

const camtJson = ref(null)
const balPRCD = ref(null) // Endsaldo gebucht vorheriger Auszug
const balCLAV = ref(null) // Endsaldo verfügbar des Auszugs
const balCLBD = ref(null) // Endsaldo gebucht des Auszugs
const camtTransactions = ref([])

async function handleFileChange() {
  fileCamtToAnalyse.value = fileInput.value?.files[0]


  balPRCD.value = null;
  balCLAV.value = null;
  balCLBD.value = null;


  $log.info(`files changed for ${fileCamtToAnalyse.value}`)
  fileCamtToAnalyseContexnts.value=await fileCamtToAnalyse.value.text();

  camtJson.value=xml2json.xml2js(fileCamtToAnalyseContexnts.value, {compact: true, spaces: 4})
  // $log.debug("camtJson: ",camtJson)

  const balsArray = camtJson.value.Document.BkToCstmrStmt.Stmt.Bal;
  $log.debug("Stmt: ",balsArray)
  balPRCD.value = balsArray.filter(element => element.Tp?.CdOrPrtry?.Cd?._text === "PRCD")[0]
  balCLAV.value = balsArray.filter(element => element.Tp?.CdOrPrtry?.Cd?._text === "CLAV")[0]
  balCLBD.value = balsArray.filter(element => element.Tp?.CdOrPrtry?.Cd?._text === "CLBD")[0]
  // $log.debug("balPRCD: ",balPRCD.value)
  // $log.debug("balCLAV: ",balCLAV.value)
  // $log.debug("balCLBD: ",balCLBD.value)

  const transactionsRaw = camtJson.value.Document.BkToCstmrStmt.Stmt.Ntry;
  const transactions = Array.isArray(transactionsRaw)?transactionsRaw:[transactionsRaw];
  $log.debug("transactions: ",transactions)
  camtTransactions.value = transactions;

}

</script>
<script>
export default {
  name: 'ViewCamtPreview',
}


</script>


<template>
  <v-container class="containerBase pa-0">

    <v-container class="containerStandard">

      <p class="textHeadline">{{ $t('camt-preview') }}</p>
      View für Banktransaktionen im CAMT-Format<br/>
      <br/>

      <input ref="fileInput" type="file" @change="handleFileChange" /><br/>

      <br/>

      <div v-if="fileCamtToAnalyse">
        Dateiname: {{ fileCamtToAnalyse?.name }} <br/>
        Mime-Type: {{ fileCamtToAnalyse?.type }} <br/>
        Größe: {{ (fileCamtToAnalyse?.size/1024).toFixed(1) }}kB <br/>
      </div><br/>

<!--      <div v-if="fileCamtToAnalyseContexnts">-->
<!--      {{ fileCamtToAnalyseContexnts }}-->
<!--      </div>-->

      <div v-if="camtJson">
        MsgId: {{ camtJson?.Document.BkToCstmrStmt.GrpHdr.MsgId._text }}<br/>
        Seqenenz#: {{ camtJson?.Document.BkToCstmrStmt.Stmt.ElctrncSeqNb._text }}<br/>
        Seqenenz# (logisch): {{ camtJson?.Document.BkToCstmrStmt.Stmt.LglSeqNb._text }}<br/>
        von: {{ camtJson?.Document.BkToCstmrStmt.Stmt?.FrToDt?.FrDtTm?._text }}<br/>
        bis: {{ camtJson?.Document.BkToCstmrStmt.Stmt?.FrToDt?.ToDtTm?._text }}<br/>
      </div><br/>
      <div v-if="camtJson">
        Name: {{ camtJson?.Document.BkToCstmrStmt.Stmt.Acct?.Nm?._text }}<br/>
        IBAN: {{ camtJson?.Document.BkToCstmrStmt.Stmt.Acct?.Id?.IBAN?._text }}<br/>
        BIC: {{ camtJson?.Document.BkToCstmrStmt.Stmt.Acct?.Svcr?.FinInstnId?.BIC?._text }}<br/>
      </div><br/>
      <div v-if="camtJson">
        Endsaldo gebucht vorheriger Auszug: {{ balPRCD?.Amt?._text }}<br/>
        Endsaldo verfügbar des Auszugs:     {{ balCLAV?.Amt?._text }}<br/>
        Endsaldo gebucht des Auszugs:       {{ balCLBD?.Amt?._text }}<br/>
      </div><br/>
      <div v-if="camtJson">
        Transaktionen ein #: {{ camtJson?.Document.BkToCstmrStmt.Stmt.TxsSummry?.TtlCdtNtries?.NbOfNtries?._text }}<br/>
        Transaktionen aus #: {{ camtJson?.Document.BkToCstmrStmt.Stmt.TxsSummry?.TtlDbtNtries?.NbOfNtries?._text }}<br/>
        Transaktionen ein: €{{ camtJson?.Document.BkToCstmrStmt.Stmt.TxsSummry?.TtlCdtNtries?.Sum?._text }}<br/>
        Transaktionen aus: €{{ camtJson?.Document.BkToCstmrStmt.Stmt.TxsSummry?.TtlDbtNtries?.Sum?._text }}<br/>
      </div><br/>

      <div v-if="camtJson">Transaktionen gefunden</div>
      <div v-for="(transaction, index) in camtTransactions">
        {{ index+1 }}:
          {{ transaction.ValDt.Dt._text }}
          {{ transaction.CdtDbtInd._text }}
          €{{ transaction.Amt._text }}
        {{ transaction.AcctSvcrRef?._text }}
        {{ transaction.NtryDtls?.TxDtls?.Refs?.EndToEndId?._text }}
        <br/>
        <!-- {{ transaction }}-->
      </div><br/>

<!--      <pre v-if="camtJson">-->
<!--        {{ camtJson }}-->
<!--      </pre>-->



    </v-container>
  </v-container>
</template>

<style>


</style>
